import { render } from "./ItemEditArticle.vue?vue&type=template&id=379f4caf&scoped=true&bindings={\"modelValue\":\"props\",\"item\":\"data\",\"editorHeight\":\"data\",\"tinyOptions\":\"options\",\"setEditorHeight\":\"options\"}"
import script from "./ItemEditArticle.vue?vue&type=script&lang=js"
export * from "./ItemEditArticle.vue?vue&type=script&lang=js"

import "./ItemEditArticle.vue?vue&type=style&index=0&id=379f4caf&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-379f4caf"

export default script